/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Customer Content API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ContentItemResponse,
    ContentItemResponseFromJSON,
    ContentItemResponseFromJSONTyped,
    ContentItemResponseToJSON,
    ContentItemType,
    ContentItemTypeFromJSON,
    ContentItemTypeFromJSONTyped,
    ContentItemTypeToJSON,
    ContentItemTypeResponseAllOf,
    ContentItemTypeResponseAllOfFromJSON,
    ContentItemTypeResponseAllOfFromJSONTyped,
    ContentItemTypeResponseAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface ContentItemTypeResponse
 */
export interface ContentItemTypeResponse {
    /**
     * 
     * @type {string}
     * @memberof ContentItemTypeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ContentItemTypeResponse
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ContentItemTypeResponse
     */
    contents: string;
    /**
     * 
     * @type {ContentItemType}
     * @memberof ContentItemTypeResponse
     */
    type?: ContentItemType;
}

export function ContentItemTypeResponseFromJSON(json: any): ContentItemTypeResponse {
    return ContentItemTypeResponseFromJSONTyped(json, false);
}

export function ContentItemTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContentItemTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'contents': json['contents'],
        'type': !exists(json, 'type') ? undefined : ContentItemTypeFromJSON(json['type']),
    };
}

export function ContentItemTypeResponseToJSON(value?: ContentItemTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'title': value.title,
        'contents': value.contents,
        'type': ContentItemTypeToJSON(value.type),
    };
}


